import React, { useEffect, useMemo, useState } from "react";
import { apiClient } from "@/lib/auth";
import { EngineRow } from "@/components/nds/windows/resident/access/EngineRows";

const PORTAL = [["workers", "My workers"], ["hours", "Hours"], ["invoices", "Invoices"], ["messages", "Memos"], ["docs", "Agreements"]];

/** Super Admin only: which cards this vendor can use — their portal cards plus any platform card (opened from their portal's Platform tab). */
export const VendorCards = ({ vendorId, value, onChange }) => {
  const [cat, setCat] = useState(null);
  useEffect(() => {
    Promise.all([apiClient.get("/access/catalog"), apiClient.get(`/access/person/vendor/${vendorId}`)])
      .then(([c, p]) => { setCat(c.data); onChange((v) => ({ ...v, access: p.data.card_access || {}, orig: p.data.card_access || {} })); }).catch(() => {});
  }, [vendorId]); // eslint-disable-line react-hooks/exhaustive-deps
  const engines = useMemo(() => (cat?.engines || []).map((e) => ({ ...e, cards: e.cards.filter((c) => !c.sa_only) })).filter((e) => e.cards.length), [cat]);
  const setAccess = (fn) => onChange((v) => ({ ...v, access: fn(v.access || {}) }));
  const set = (id, lv) => setAccess((d) => { const n = { ...d }; if (lv) n[id] = lv; else delete n[id]; return n; });
  const setMany = (ids, lv, isSee) => setAccess((d) => { const n = { ...d }; ids.forEach((id) => { if (!lv) delete n[id]; else if (isSee) n[id] = n[id] || "view"; else n[id] = lv; }); return n; });
  const togglePortal = (k) => onChange((v) => ({ ...v, portal: v.portal.includes(k) ? v.portal.filter((x) => x !== k) : [...v.portal, k] }));
  const granted = Object.keys(value.access || {}).length;
  return (
    <div className="space-y-3" data-testid="cv-cards">
      <div>
        <div className="text-[11px] text-white/50 mb-1.5">Vendor portal cards</div>
        <div className="flex flex-wrap gap-2">{PORTAL.map(([k, l]) => (
          <label key={k} className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs cursor-pointer transition-colors ${value.portal.includes(k) ? "border-[#d4a017] text-[#d4a017] bg-[#d4a017]/10" : "border-white/15 text-white/50"}`}>
            <input type="checkbox" className="sr-only" checked={value.portal.includes(k)} onChange={() => togglePortal(k)} data-testid={`cv-portal-card-${k}`} />{l}</label>))}</div>
      </div>
      <div>
        <div className="text-[11px] text-white/50 mb-1.5" data-testid="cv-platform-count">Platform cards · {granted} granted · they open these from a Platform tab in their portal</div>
        {!cat || value.access === null ? <div className="text-xs text-white/40">Loading cards…</div>
          : <div className="max-h-64 overflow-y-auto space-y-1.5 pr-1">{engines.map((e) => <EngineRow key={e.id} engine={e} access={value.access} set={set} setMany={setMany} locked={false} />)}</div>}
      </div>
    </div>
  );
};
